import * as utils from "common/utils";
import ActionLink from "components/ActionLink";

export default function DownloadMapLink({ farm, analysis }) {

    const hasMap = analysis?.features?.length > 0;
    if (!hasMap) {
        return null;
    }

    const downloadMap = () => {
        // Create a GeoJSON FeatureCollection from the analysis features
        const geoJson = {
            type: "FeatureCollection",
            features: analysis.features
        };

        // Trigger the download
        utils.downloadGeoJsonFile(geoJson, `${farm.name}-${analysis.name}.geojson`);
    };

    return (
        <>
            <ActionLink id="import-map" className="IconLink--download" onClick={downloadMap}>
                Download farm map (GeoJSON)
            </ActionLink>
        </>
    )
}
